import {
  PHONE_CODES_LOADING,
  PHONE_CODES_ERROR,

  PHONE_CODES_LIST,
  PHONE_CODES_CREATE,
  // PHONE_CODES_UPDATE,
  PHONE_CODES_DELETE,
  PHONE_CODES_FILTERS,
} from "actions/phone-codes/constants";

const initialState = {
  loading: false,
  errors: [],

  list: [],
  filters: []
};

export default function (state = initialState, action) {
  let list = [],
    index;
  switch (action.type) {
    case PHONE_CODES_LOADING:
      return {
        ...state,
        loading: action.payload.content
      };
    case PHONE_CODES_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.payload.content
      };
    case PHONE_CODES_LIST:
      return {
        ...state,
        errors: [],
        loading: false,
        list: action.payload.content,
      };
    case PHONE_CODES_CREATE:
      list = Object.assign([], state.list);
      if (action.payload.create) {
        list.push(action.payload.data);
      } else {
        index = list.findIndex(item => item.id === action.payload.data.id);
        if (index > -1) {
          list[index] = action.payload.data;
        }
      }

      return {
        ...state,
        errors: [],
        loading: false,
        list
      };
    case PHONE_CODES_DELETE:
      list = Object.assign([], state.list);
      index = list.findIndex(item => item.id === action.payload);
      if (index > -1) {
        list.splice(index, 1);
      }
      return {
        ...state,
        errors: [],
        loading: false,
        list
      };
    case PHONE_CODES_FILTERS:
      return {
        ...state,
        loading: false,
        filters: action.payload
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/phoneCodesReducer.js